import { render, staticRenderFns } from "./PelatihanPesertaPostTest.vue?vue&type=template&id=e8d49e16"
import script from "./PelatihanPesertaPostTest.vue?vue&type=script&lang=js"
export * from "./PelatihanPesertaPostTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports